module.exports = __webpack_public_path__ + "assets/img/fncthree.e465018b.png";